module.exports = __webpack_public_path__ + "media/08.280ed197.mp4";